import React, { useState, useCallback, useEffect, useRef } from "react";
import { useSearch } from "@usereactify/search";
import { SearchForm } from "../Form/SearchForm";
import { InstantSearchResults } from "./InstantSearchResults";

import { useCalculateOverlay } from "../../hooks/useCalculateOverlay";
import { useIsMobile } from "../../hooks/useIsMobile";

export const InstantSearchOverlay: React.FC<Props> = ({ isOpen, toggleIsOpen }) => {
  const { searchTerm, setSearchTerm } = useSearch();
  const { overlayHeight, overlayTop } = useCalculateOverlay();
  const [delayedShowResults, setDelayedShowResults] = useState(false);
  const { isMobile } = useIsMobile();
  const timeout = useRef<any>(null);

  // const classes = `fixed overflow-auto left-0 top-0 w-full h-full z-10 bg-black/40 ${
  //   isOpen ? "visible opacity-100 transition-opacity" : "opacity-0 invisible transition-all"
  // }`;

  const handleChildClick = useCallback((e) => e.stopPropagation(), []);

  // add a delay in between toggling results as it's too jumpy otherwise
  useEffect(() => {
    if (searchTerm?.length) {
      setDelayedShowResults(true);
      if (!delayedShowResults) {
        timeout.current = setTimeout(() => setDelayedShowResults(true), 400);
      }
    } else {
      clearTimeout(timeout.current);
      setDelayedShowResults(false);
    }
  }, [searchTerm]);

  const top = isMobile ? 0 : overlayTop;
  const height = isMobile ? overlayTop + overlayHeight : overlayHeight;

  return (
    <div onClick={toggleIsOpen}>
      <div onClick={handleChildClick}>
        <SearchForm />
        {delayedShowResults && <InstantSearchResults />}
      </div>
    </div>
  );
};

type Props = {
  isOpen: boolean;
  toggleIsOpen: () => void;
};
